import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import DetailOrder from '../DetailOrder';
import getGlobal from '../../Queries/getGlobal';

//Styles
import styles from './index.module.sass';

export default function ItemOrder({ screenSize, setSessionMessage, order, getPedidosCatalogo }) {
  const [detail, setdetail] = useState('');
  const [active, setactive] = useState(false);
  const [dataDetail, setdataDetail] = useState([]);
  const [loading, setloading] = useState(false);
  const { t } = useTranslation('digitalOrders');

  const meses = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getDetallePedidoCatalogo = useCallback(
    async (item) => {
      setloading(true);
      setdetail(item);
      setactive(true);
      if (item === detail) {
        setactive(!active);
      } else {
        const response = await getGlobal({
          tmbservice: 'getDetallePedidoCatalogo',
          jsonBody: {
            idPedido: item,
            idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          },
        });

        const { typeMessage, detalle } = response;

        if (typeMessage === 'success') {
          setdataDetail(detalle);
        }
      }
      setloading(false);
    },
    [detail, active],
  );

  return (
    <div className={styles.row}>
      <div className={styles.table}>
        <div className={`${styles.text} ${styles[detail === order.idPedido]}`}>
          {meses[parseInt(order.fechaPedido.substring(4, 6)) - 1]}-{order.fechaPedido.substring(6)}-
          {order.fechaPedido.substring(0, 4)}
        </div>
        <div className={`${styles.text} ${styles[detail === order.idPedido]}`}>{order.nombre}</div>
        <div className={`${styles.text} ${styles[detail === order.idPedido]}`}>${order.total}</div>
        <div className={`${styles.text} ${styles[detail === order.idPedido]}`}>{order.estatus}</div>
        <div
          className={`${styles.textClick} ${styles[detail === order.idPedido]}`}
          onClick={() => getDetallePedidoCatalogo(order.idPedido)}>
          <label className={styles.line}>
            {screenSize !== 'phone' && (
              <i className={`material-icons-outlined ${styles.icon}`}>
                {detail === order.id && active ? 'expand_less' : 'expand_more'}
              </i>
            )}
            <span className={styles.span}>{t('detail')}</span>
          </label>
        </div>
      </div>
      <div className={detail === order.idPedido && active ? styles.block : styles.none}>
        <DetailOrder
          screenSize={screenSize}
          dataDetail={dataDetail}
          detailCabecero={order}
          loading={loading}
          setSessionMessage={setSessionMessage}
          getPedidosCatalogo={getPedidosCatalogo}
        />
      </div>
    </div>
  );
}
